module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('brand-table')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 此區可新增、編輯品牌下所有菜單的內容")]), _vm._v(" "), _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如需建立某張菜單，請至菜單管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189d270a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/MenuDetailTable.vue
// module id = 2339
// module chunks = 1